module.exports = __webpack_public_path__ + "img/about-why.e3d0cedd.jpg";